import { useTranslation } from "react-i18next";
import { Locale } from "common/models";

export default function useLocale() {
    const { i18n } = useTranslation();
    return i18n.language as Locale;
}
